/*
 */
export enum EBEvt {
  G_AUTH_SIGNOUT = 'global:auth:signout',
  G_AUTH_TOKEN_ACCESS = 'global:auth:token:access',
  G_AUTH_TOKEN_REFRESH = 'global:auth:token:refresh',
}
